import { useWeb3React } from '@web3-react/core'
import { usePendingChainId } from '~/state/user/hooks'

export const useCurrentChainId = () => {
  const { account, chainId } = useWeb3React()
  const pendingChainId = usePendingChainId()
  return account ? chainId : pendingChainId
}
